export default __webpack_public_path__ + "static/media/grapiechar.e248b137.png";